import styled from 'styled-components';

export const StyledUserPanelResultsFirstDivIcons = styled.div`
    min-width: 131px;
    width: 15%;
    min-height: 30px;
`;
